const UNIT_LOCALES = {
  IMPERIAL: 'imperial',
  METRIC: 'metric',
};

export default UNIT_LOCALES;
